import { IRecordsOf } from 'src/app/common/models/IRecordsOf';


export class SetRecordsOfData {
    static readonly type = '[IRecordsOf] Set RecordsOf Data';

    constructor(public data: IRecordsOf) {}
}

export class ClearRecordsOf {
    static readonly type = '[IRecordsOf] Clear RecordsOf State';

    constructor() {}
}
